import React, { useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Avatar, Grid, Typography } from '@mui/material';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
import { Stack } from 'react-bootstrap';
import Iconify from '../iconify/Iconify';
import ChangePassModal from './ChangePassModal';
import { glb_sv } from 'src/utils';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const ProfileModal = ({ visible = false, dataUpdate, setVisible, fuctGet, idPermission, isEdit }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [visibleChange, setVisibleChange] = useState(false);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <ChangePassModal visible={visibleChange} setVisible={setVisibleChange} />
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {t('info_account')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item style={{ width: '100%' }} xl={12} md={12} sm={12}>
                        <Stack direction="row" style={{ display: 'flex', gap: 0.5 }} spacing={2}>
                            <Avatar width={60} height={60} size="lg" />
                            <Typography variant="subtitle1" color={'#555'} fontSize={22} noWrap paddingLeft={0.5}>
                                {dataUpdate?.user_nm}
                            </Typography>
                        </Stack>
                    </Grid>
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <Stack
                            direction="row"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                color: (theme) => theme.palette['primary'].light,
                            }}
                            spacing={2}
                        >
                            <Typography color={(theme) => theme.palette['primary'].dark}>
                                <Iconify icon="material-symbols:contact-mail" />
                            </Typography>
                            <Typography variant="subtitle1" color={'#555'} noWrap paddingLeft={0.5}>
                                {dataUpdate?.email}
                            </Typography>
                        </Stack>
                    </Grid>{' '}
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <Stack direction="row" style={{ display: 'flex', alignItems: 'center', gap: 0.5 }} spacing={2}>
                            <Typography color={(theme) => theme.palette['primary'].light}>
                                <Iconify icon="material-symbols:contact-phone-rounded" />
                            </Typography>
                            <Typography variant="subtitle1" color={'#555'} noWrap paddingLeft={0.5}>
                                {dataUpdate?.phone}
                            </Typography>
                        </Stack>
                    </Grid>{' '}
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <Stack direction="row" style={{ display: 'flex', alignItems: 'center', gap: 0.5 }} spacing={2}>
                            <Typography color={(theme) => theme.palette['primary'].light}>
                                <Iconify icon="material-symbols:speaker-group-rounded" />
                            </Typography>
                            <Typography variant="subtitle1" color={'#555'} noWrap paddingLeft={0.5}>
                                {dataUpdate?.departs_nm || ''}
                            </Typography>
                        </Stack>
                    </Grid>{' '}
                    <Grid item style={{ width: '100%' }} xl={6} md={6} sm={12}>
                        <Stack direction="row" style={{ display: 'flex', alignItems: 'center', gap: 0.5 }} spacing={2}>
                            <Typography
                                color={(theme) => theme.palette['primary'].light}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <Iconify icon="material-symbols:groups" width={25} height={25} />
                            </Typography>
                            <Typography variant="subtitle1" color={'#555'} noWrap paddingLeft={0.5}>
                                {dataUpdate?.key_mean || ''}
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction onClick={() => setVisible(!visible)} type={'cancel'} title={t('cancel')} />
                <ButtonAction type={'change'} onClick={() => setVisibleChange(true)} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default ProfileModal;
